import React from "react";
import loadable from "@loadable/component";

const Animation = loadable(() => import("./Animation/index"));

const Orbit: React.FC<{}> = () => {
  return (
    <>
      <Animation />
    </>
  );
};

export default Orbit;
